<style src="css/feedback.css" scoped></style>
<template>
    <div style="padding-top: 1.16rem">
        <topbar text="意见反馈"></topbar>
        <div class="textareaBox">
            <textarea v-model="content" maxlength="256" cols="30" rows="10" placeholder="请输入您的意见或建议!"></textarea>
            <div class="numBox">{{content.length}}/256</div>
        </div>
        <div class="btnBox" @click="send">提交</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                content:'',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async send() {
                let data = await getSources("/bear-scale/api/scaleUser/doScaleUserMessage.json",{
                    content:this.content,
                    userId:localStorage.getItem('userId'),
                });
                if (data.status === 0) {
                    alert('提交成功')
                    this.content=''
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/feedback.vue?412c381b